import { render, staticRenderFns } from "./TestimonialTwo.vue?vue&type=template&id=cd2bcd66"
import script from "./TestimonialTwo.vue?vue&type=script&lang=js"
export * from "./TestimonialTwo.vue?vue&type=script&lang=js"
import style0 from "./TestimonialTwo.vue?vue&type=style&index=0&id=cd2bcd66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports